import createAxios from 'config/axios'

export const getBrokers = () => //eslint-disable-line
  createAxios.get('/aparatar/v1/brokers', undefined, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('access_token')}`
    }
  })
